module.exports = __webpack_public_path__ + "img/image-disclaimer_browser.cf7c6ae5.png";